/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * @param {?} value
 * @return {?}
 */
export function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false' && "" + value !== '';
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/core/coersion/boolean-property.js
// module id = 1371
// module chunks = 31